export function welcome(name) {
  return [
    {
      title: 'Welcome',
      intro:
        'Hello ' + name + " <br> Let me take you on a Quick Tour. Let's Go!",
    },
  ];
}

export function headerMenu() {
  return [
    {
      title: 'Browse Courses',
      element: document.querySelector('#browseCourseLink'),
      intro: 'Easy to browse Courses, Modules, and Units with Category filter.',
    },
    {
      title: 'How’s your Dealer performing?',
      element: document.querySelector('#header-menu__secret-shops'),
      intro:
        'See how your dealer performed against your competitors with our comprehensive mystery shopping data. ',
    },
    {
      title: 'Training Tools',
      element: document.querySelector('#header-menu__on-demand-training'),
      intro:
        'Start Learning and watch thousands of videos with cool features such as creating study playlists, add to favorites and assign or share modules within your organization.',
    },
    {
      title: 'On-Demand Training Report',
      element: document.querySelector('#header-menu__otd-report'),
      intro:
        'Summarize and compare the progress of your trainees and Track the Team’s performance.',
    },
    {
      title: 'Download Now!',
      element: document.querySelector('#header-menu__file-manager'),
      intro: 'Download call guides and best practices from your File Manager.',
    },
  ];
}

export function menuMobile() {
  return [
    {
      title: 'Explore our Website!',
      element: document.querySelector('#kt_header_mobile'),
      intro:
        'We offer you Great Tools to help expand your skills and become a Better Salesperson. ',
    },
  ];
}

export function asideMenu() {
  return [
    {
      position: 'right',
      title: 'Quick Access of your Content',
      element: document.querySelector('.kt-aside #aside-menu__dashboard'),
      intro:
        'Quick Access of the Important data to keep track; such as Monthly Users and Dealer, Video of the day, and Webinar Calendar.',
    },
    {
      position: 'right',
      title: 'Build Course Now!',
      element: document.querySelector('.kt-aside #aside-menu__lms-management'),
      intro:
        'Share your knowledge and create courses for Trainees. You can create modules and quizzes.',
    },
    {
      position: 'right',
      title: 'How’s the Salesperson performed?',
      element: document.querySelector(
        '.kt-aside #aside-menu__secret-shop-management'
      ),
      intro:
        "Record the details of the Customer Service you encountered. Those records are crucial for the Dealers' Competition. Let’s see who performed the best!",
    },
    {
      position: 'right',
      title: 'Manager Users and Group Users',
      element: document.querySelector('.kt-aside #aside-menu__manage-users'),
      intro:
        'Manage all Users within your Organization and create Teams using the Group User feature.',
    },
    {
      position: 'right',
      title: 'Modify Account',
      element: document.querySelector('.kt-aside #aside-menu__profile'),
      intro: 'Manager your Account and LMS Setting.',
    },
  ];
}

export function contentHome() {
  return [
    {
      position: 'right',
      title: 'Start Learning Today!',
      element: document.querySelector('#top-widget__course-library'),
      intro:
        'Go to your Course Library to watch thousands of videos to learn how to be a better salesperson.',
    },
    {
      position: 'right',
      title: 'How’s your Dealer performing?',
      element: document.querySelector('#top-widget__mystery-shopping'),
      intro:
        'See how your dealer performed against your competitors with our comprehensive mystery shopping data.',
    },
    {
      position: 'left',
      title: 'Download Now!',
      element: document.querySelector('#top-widget__file-manager'),
      intro: 'Download call guides and best practices from your File Manager.',
    },
    {
      position: 'right',
      title: 'Continue Learning?',
      element: document.querySelector('#lms-widget__in-progress'),
      intro:
        'See the current modules you’re working on; with your progress percentage.',
    },

    {
      position: 'right',
      title: 'Modules or Playlists assigned to you',
      element: document.querySelector('#lms-widget__assigned'),
      intro:
        'Quick Access to the modules or playlist assigned to you with a due date. Finish before the deadline.',
    },
    {
      position: 'left',
      title: 'Your Playlist',
      element: document.querySelector('#lms-widget__playlist'),
      intro: 'Quick access to your Playlist.',
    },
  ];
}

export function webinarCard() {
  return [
    {
      position: 'top',
      title: 'Schedule your Upcoming Events',
      element: document.querySelector('#client-home__webinar'),
      intro: 'Keep track of your Webinars Schedule and be notified.',
    },
  ];
}

export function userManager() {
  return [
    {
      title: 'All Registered Companies',
      element: document.querySelector('#user-manager__dealer'),
      intro:
        'Add Company and Modify their Information, Dashboard Layouts, and Secret Shop Setting.',
    },
    {
      title: 'All Registered Users',
      element: document.querySelector('.user-manager__user'),
      intro:
        'Manage users, assigned roles, and approve/reject registered users.',
    },
    {
      title: 'Build a Team!',
      element: document.querySelector('#user-manager__group-user'),
      intro:
        'The Group User feature will let you create and group your members to form a team.',
    },
  ];
}

export function lmsManager() {
  return [
    {
      title: 'Let’s create LMS Data',
      intro:
        'The sequence of creating LMS Data is COURSE -> CATEGORY -> MODULE -> UNITS.',
    },
    {
      title: 'Course Manager',
      element: document.querySelector('#lms-manager__course'),
      intro: 'On creating courses, you need to assigned Dealer(s)',
    },
    {
      title: 'Category Manager',
      element: document.querySelector('#lms-manager__category'),
      intro:
        'After creating a course, you must assign it to a category. Create New or assigned it to the existing category.',
    },
    {
      title: 'The Module is a Group of Units',
      element: document.querySelector('#lms-manager__module'),
      intro: 'On creating modules, you must assign a category.',
    },
    {
      title: 'Unit is the topic per Module',
      element: document.querySelector('#lms-manager__unit'),
      intro:
        ' - On creating a Unit, you can include videos or quizzes you build. <br> - Module Progress based on the completion of Units',
    },
    {
      title: 'Quiz Builder',
      element: document.querySelector('#lms-manager__quiz'),
      intro: 'Build quiz with multiple choice template',
    },
    {
      title: 'Now, Let’s Build LMS ',
      element: document.querySelector('#lms-manager__lms-builder'),
      intro:
        'Once you created the LMS Data, you must build it to produce LMS Template.',
    },
  ];
}

export function lmsBuilder() {
  return [
    {
      title: 'Let’s Build LMS Template',
      intro:
        'The sequence of building LMS Template is MODULE -> CATEGORY -> COURSE',
    },
    {
      title: 'Build the Module ',
      element: document.querySelector('#lms-builder__module'),
      intro:
        '- Select the Course you want to build and its corresponding Modules. <br> - On Building Series, you will group the Units ',
    },
    {
      title: 'Build The Category ',
      element: document.querySelector('#lms-builder__category'),
      intro: 'Select the Course, Module and Module Build you created.',
    },
    {
      title: 'Build the Course',
      element: document.querySelector('#lms-builder__course'),
      intro:
        'For the last step, select the Course and the Category Build you created.',
    },
  ];
}

export function onDemandTraining() {
  return [
    {
      title: 'Quick Access on Helpful Tools',
      element: document.querySelector('#client-lms__shotcuts'),
      intro:
        '- These features will help you organize Units to find them easily. Add Units to your Playlist or Favorites. <br> - See What’s Trending Units of your Organization.',
    },
    {
      title: 'Learn Now!',
      element: document.querySelector('#client-lms__module-0'),
      intro:
        'See the Module and its progress based on per unit’s completion. Share and Assign it to your co-trainees.',
    },
    {
      title: 'Modules Series',
      element: document.querySelector('#client-lms__series-0'),
      intro: 'Unit(s) you must accomplish to finish the module.',
    },
  ];
}

export function unitCard() {
  return [
    {
      position: 'right',
      title: 'Let’s Learn ',
      element: document.querySelector('#unit-card-0'),
      intro:
        'Topic per module with videos you can study. Start Learning Today How to Become Better Salesperson!',
    },
    {
      position: 'right',
      title: 'Unit’s Options',
      element: document.querySelector('#unit-card__control-0'),
      intro:
        '- Click “Add to Playlist” or “Favorite” to add to your list. <br> - Click “More” to see the Assign / Share Option. <br> - Click the arrow down to view the details',
    },
  ];
}

export function unitPage() {
  return [
    {
      position: 'right',
      title: 'Let’s Learn',
      element: document.querySelector('#unit-page__unit-desc'),
      intro:
        'With an informative webinar that you can study. Take a Quiz to see How well you understand the Lesson.',
    },
    {
      position: 'left',
      title: 'Unit Progress',
      element: document.querySelector('#unit-page__progress'),
      intro:
        'Track the progress of your Unit. Finish all the tasks to have a score.',
    },
    {
      title: 'Submit when you have completed',
      element: document.querySelector('#unit-page__submit'),
      intro:
        'Click submit once you’re done so you can proceed to the next Unit.',
    },
    {
      title: 'List of the Units you must complete',
      element: document.querySelector('#unit-page__related'),
      intro:
        'It’s not necessary to take the Units in chronological order. Feel free to choose whatever you want to accomplish first.',
    },
    {
      title: 'What’s on your mind?',
      element: document.querySelector('#unit-page__note'),
      intro:
        'Did you learn something new? Post your comment or suggestions. Let us know your thoughts.',
    },
  ];
}

export function OTDReport() {
  return [
    {
      position: 'right',
      title: 'Who are your Top Performers?',
      element: document.querySelector('#report-overview'),
      intro:
        'Check the summary progress of your Trainees (Salespersons) and see who’s performing the best',
    },
    {
      position: 'left',
      title: 'Track the performance of your Trainees (Salesperson)',
      element: document.querySelector('#report-module'),
      intro: 'Fetch the Summary Report and control it using filters. ',
    },
    {
      title: 'Check the Team’s Progress',
      element: document.querySelector('#report-team'),
      intro:
        'With the Percentage of the Units completed, track and compare the progress of your Trainees.',
    },
  ];
}

export function secretShop() {
  return [
    {
      title: 'Summary of your Dealer’s performance',
      element: document.querySelector('#client-shop__summary'),
      intro:
        'Reported by our Highly Trained Agents (Secret Shopper) acted as Leads. According to InsideSales, 50% of buyers choose the vendor that responds first. Quick Response time sends [a message] about respect, urgency, importance, and enthusiasm.',
    },
    {
      title: 'Compare your Dealer against Competitor',
      element: document.querySelector('#client-shop__comparison'),
      intro:
        'Being aware of your Competition is extremely important. Once you are aware, you will have an urge to improve your Salesforce and aim for higher and much better performance.',
    },
    {
      title: 'Monitor your Sales Team',
      element: document.querySelector('#client-shop__internet'),
      intro:
        'Using our Mystery Shopping, you can track the performance of your Sales Team; with detailed information such as Call Records, SMS and Emails',
    },
    {
      title: 'See your Sales Team’s Grades against Competitor',
      element: document.querySelector('#client-shop__phone'),
      intro:
        'Our Secret Shopper graded and compared the performance of your Dealer and the selected Competitor. See the detailed results.',
    },
    {
      title: 'List of all your Comparison',
      element: document.querySelector('#client-shop__group'),
      intro:
        'Create a group and check statistic comparison of Internet Shop and Phone Shop (For Account Manager Only)',
    },
  ];
}

export function sendReport(hasExcel = false) {
  return [
    {
      element: document.querySelector('.send-report'),
      intro: hasExcel
        ? 'Get a Copy of the Comparison Details. Export to Excel or send thru Emails'
        : 'Get a Copy of the Sales Support Details and send thru Emails',
    },
  ];
}

export function profile() {
  return [
    {
      title: 'Basic Information',
      element: document.querySelector('#profile-info'),
      intro: 'Check your Basic Information and upload your profile picture',
      position: 'right',
    },
    {
      element: document.querySelector('#profile-modify'),
      intro: 'Check and modify your Information',
      position: 'left',
    },
    {
      element: document.querySelector('#profile-lms-setting'),
      intro: 'Change your LMS preference',
      position: 'left',
    },
    {
      element: document.querySelector('#profile-lms-report'),
      intro: 'Track all your LMS summary progress and pending',
      position: 'top',
    },
  ];
}
